
import MuiDivider from '@mui/material/Divider';
import { styled } from '@mui/material';
import { spacing, SpacingProps } from '@mui/system';
import { isNotSpacingProp } from '../../Utils/spacingUtils';

interface IProps extends SpacingProps {
  variant?: 'fullWidth' | 'inset' | 'middle';
}

/**
 * Separerande linje mellan två element eller sektioner.
 */
export const EDDivider: React.FC<React.PropsWithChildren<IProps>> = styled(
  MuiDivider,
  {
    name: 'EDDivider',
    shouldForwardProp: isNotSpacingProp,
  }
)(spacing);

export default EDDivider;
